module.exports = __webpack_public_path__ + "img/DE02350.bd04fc6b.png";